import React from 'react';
import { Button, Card, Col, Row } from 'react-bootstrap';

import { useNotifications } from '../../common/hooks/useNotifications';
import { usePokCore } from '../../common/hooks/usePokCore';
import { useTranslation } from '../../common/hooks/useTranslation';

import { getPdf } from './getPdf';

export const InstructionsENView: React.FC = () => {
  const pok = usePokCore();
  const notifications = useNotifications();
  const { t, tk } = useTranslation('menuLng');

  const getTempPdf = (name: string) => {
    getPdf(pok, notifications, name);
  };

  return (
    <>
      <Card className="main-card">
        <Card.Body className="m-3">
          <Card.Title className="pb-3">{t(tk.menu.instructions)}</Card.Title>
          <div className="d-grid gap-2">
            <Row>
              <Col md={6}>
                <div className="d-grid gap-2">
                  <Button
                    variant="outline-primary"
                    size="lg"
                    onClick={() =>
                      getTempPdf(
                        'instructions/en/POK - Setting up campaigns and completing applications.pdf',
                      )
                    }
                  >
                    {t(tk.prLang.settingUpProjects)}
                  </Button>
                  <Button
                    variant="outline-primary"
                    size="lg"
                    onClick={() =>
                      getTempPdf(
                        'instructions/en/POK - Importing positions from a campaign to a campaign.pdf',
                      )
                    }
                  >
                    {t(tk.prLang.importFromProjectToProject)}
                  </Button>
                  <Button
                    variant="outline-primary"
                    size="lg"
                    onClick={() =>
                      getTempPdf('instructions/en/POK - Campaign orders.pdf')
                    }
                  >
                    {t(tk.prLang.projectOrders)}
                  </Button>
                  <Button
                    variant="outline-primary"
                    size="lg"
                    onClick={() =>
                      getTempPdf(
                        'instructions/en/POK - Order executions (specialist).pdf',
                      )
                    }
                  >
                    {t(tk.docs.orderFulfillment)}
                  </Button>
                  <Button
                    variant="outline-primary"
                    size="lg"
                    onClick={() =>
                      getTempPdf(
                        'instructions/en/POK - Acceptance of invoices.pdf',
                      )
                    }
                  >
                    {t(tk.docs.acceptanceInvoices)}
                  </Button>
                  <Button
                    variant="outline-primary"
                    size="lg"
                    onClick={() =>
                      getTempPdf(
                        'instructions/en/POK - Import campaigns from sheets.pdf',
                      )
                    }
                  >
                    {t(tk.prLang.importProjectsFromFile)}
                  </Button>
                </div>
              </Col>
            </Row>
          </div>
        </Card.Body>
      </Card>
    </>
  );
};
